// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Cursor_wrapper__2s5Tm","inner":"Cursor_inner__aAFif","outer":"Cursor_outer__B9udv"};